import React from "react";
import { Polyline } from "react-leaflet";

const COMPLETE_STYLE = {
  color: "#3BAFDA",
  weight: 1.5,
  opacity: 1,
};

const PENDING_STYLE = {
  color: "#7A7B7D",
  weight: 1.5,
  opacity: 1,
  dashArray: "2 5",
  lineCap: "round",
  lineJoin: "round",
};

const EMPTY_ROUTES = { completedRoute: [], pendingRoute: [] };

const ShipmentSeaRoutePolylines = ({ origin, current, destination }) => {
  const [routes, setRoutes] = React.useState(EMPTY_ROUTES);

  React.useEffect(() => {
    if (!origin || !destination) {
      setRoutes(EMPTY_ROUTES);
      return undefined;
    }

    let cancelled = false;

    import("../../helper/seaRoute")
      .then(({ buildSeaRoutesForShipment }) => {
        if (cancelled) return;
        setRoutes(buildSeaRoutesForShipment(origin, current, destination));
      })
      .catch((error) => {
        console.warn("Sea route module failed to load:", error);
        if (cancelled) return;
        setRoutes({
          completedRoute: current ? [origin, current] : [],
          pendingRoute: current ? [current, destination] : [origin, destination],
        });
      });

    return () => {
      cancelled = true;
    };
  }, [origin, current, destination]);

  if (!origin || !destination) return null;

  const { completedRoute, pendingRoute } = routes;

  return (
    <>
      {pendingRoute.length >= 2 ? (
        <Polyline
          positions={pendingRoute.map((p) => [p.lat, p.lng])}
          pathOptions={PENDING_STYLE}
        />
      ) : null}
      {completedRoute.length >= 2 ? (
        <Polyline
          positions={completedRoute.map((p) => [p.lat, p.lng])}
          pathOptions={COMPLETE_STYLE}
        />
      ) : null}
    </>
  );
};

export default ShipmentSeaRoutePolylines;
